import SySolarSystem from "./sy-solar-system";

export default SySolarSystem